import React from "react";

export const Policy = () => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-12">
            <div className="about-text">
              <h2>Privacy Policy</h2>
              <h3>Bible – iTreasure Kids</h3>

              <p>
                Bible – iTreasure Kids (“we”, “our”, “us”) respects your privacy
                and is committed to protecting the personal information of our
                users, especially children. This Privacy Policy explains how we
                collect, use, and protect information when you use our platform.
              </p>

              {/* 1. Information We Collect */}
              <h3>1. Information We Collect</h3>

              <h4>a. Personal Information</h4>
              <ul>
                <li>Name or nickname</li>
                <li>Age group selection</li>
                <li>Church name (optional)</li>
                <li>Profile image (optional)</li>
                <li>Email address (for support or contact)</li>
              </ul>

              <h4>b. Non-Personal Information</h4>
              <ul>
                <li>Language preferences</li>
                <li>Game progress (coins, chapters unlocked)</li>
                <li>Basic usage data to improve the platform</li>
              </ul>

              {/* 2. Children’s Privacy */}
              <h3>2. Children’s Privacy</h3>
              <ul>
                <li>This platform is designed for children and families.</li>
                <li>
                  We do not knowingly collect sensitive personal information
                  from children.
                </li>
                <li>
                  Parents or guardians are encouraged to supervise children
                  while using the platform.
                </li>
              </ul>

              {/* 3. How We Use Information */}
              <h3>3. How We Use Information</h3>
              <ul>
                <li>Provide age-appropriate Bible content</li>
                <li>Enable game progress, rewards, and leaderboards</li>
                <li>Support text-to-speech and multi-language features</li>
                <li>Improve learning experience and platform performance</li>
              </ul>

              {/* 4. Text-to-Speech & Language Features */}
              <h3>4. Text-to-Speech & Language Features</h3>
              <ul>
                <li>
                  Bible text and questions may be processed for text-to-speech.
                </li>
                <li>
                  Language preferences are stored only to improve user
                  experience.
                </li>
                <li>No voice recordings are stored permanently.</li>
              </ul>

              {/* 5. Profile Images */}
              <h3>5. Profile Images</h3>
              <ul>
                <li>Uploading a profile image is optional.</li>
                <li>Images are used only for profile display.</li>
                <li>
                  We do not sell or share profile images with third parties.
                </li>
              </ul>

              {/* 6. Leaderboard */}
              <h3>6. Leaderboard</h3>
              <ul>
                <li>
                  Leaderboards may show username, church name (if provided), and
                  scores.
                </li>
                <li>
                  No sensitive personal information is displayed publicly.
                </li>
              </ul>

              {/* 7. Cookies */}
              <h3>7. Cookies</h3>
              <ul>
                <li>
                  We may use basic cookies to remember login sessions and
                  language settings.
                </li>
                <li>We do not use cookies for advertising purposes.</li>
              </ul>

              {/* 8. Data Security */}
              <h3>8. Data Security</h3>
              <ul>
                <li>We take reasonable steps to protect user information.</li>
                <li>
                  However, no online service can guarantee complete security.
                </li>
              </ul>

              {/* 9. Third-Party Services */}
              <h3>9. Third-Party Services</h3>
              <ul>
                <li>
                  We may use trusted third-party services for hosting,
                  analytics, or text-to-speech functionality.
                </li>
                <li>
                  These services follow standard data protection practices.
                </li>
              </ul>

              {/* 10. Changes to This Policy */}
              <h3>10. Changes to This Policy</h3>
              <ul>
                <li>
                  We may update this Privacy Policy from time to time. Updates
                  will be posted on this page.
                </li>
              </ul>

              {/* 11. Contact Us */}
              <h3>11. Contact Us</h3>
              <ul>
                <li>
                  If you have any questions about this Privacy Policy, please
                  contact us at:
                </li>
                <li>📧 Email: info@itreasure.app</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Policy;
